export {
  SearchInput,
  type SearchInputProps,
} from "./components/SearchInput/SearchInput"
